import React from 'react';
import useParsePhoneNumber from '../../utils/hooks/useParsePhoneNumber';

interface Props {
  canBeTexted?: boolean,
  canBeCalled?: boolean,
  phone?: number|string,
  phoneExtn?: number|string,
}

const TextOrCall: React.FC<Props> = ({
  canBeCalled,
  canBeTexted,
  phone,
  phoneExtn,
}) => {
  const {
    isValidPhoneNumber,
    phoneCallHref,
    phoneSmsHref,
  } = useParsePhoneNumber(phone, phoneExtn);

  if (!isValidPhoneNumber) {
    return null;
  }

  return (
    <div className="text-or-call">
      {canBeTexted && (
        <>
          <i className="fas fa-comment-dots mr-2" />
          {phoneSmsHref ? (
            <a href={phoneSmsHref} className="text-secondary">TEXT</a>
          ) : (
            <span className="text-secondary">TEXT</span>
          )}
        </>
      )}
      {canBeTexted && canBeCalled && (
        <span className="mx-2">{' OR'}</span>
      )}
      {canBeCalled && (
        <>
          <i className="fab fa-whatsapp mx-2" />
          {phoneCallHref ? (
            <a href={phoneCallHref} className="text-secondary">CALL</a>
          ) : (
            <span className="text-secondary">CALL</span>
          )}
        </>
      )}
    </div>
  );
};

export default TextOrCall;
